import 'core-js/stable';
import 'regenerator-runtime/runtime'; // 用于支持 async/await
import 'swiper/css/swiper.css';
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import { initializeApp } from './config';
import * as Sentry from "@sentry/vue";

Vue.config.productionTip = false;

function createApp() {
    initializeApp();
    if(process.env.VUE_APP_ENV === "production") {
        // 前端监控
        Sentry.init({
            Vue,
            dsn: "https://94dec5283c085ecd72cc105b77de2cb5@o4510745796214784.ingest.de.sentry.io/4510745866731600",
            release: 'v1.0.0',
            integrations: [
                // Or omit `router` if you're not using vue-router
                Sentry.browserTracingIntegration({ router })
            ]
        });
    }
    new Vue({
        el: '#app',
        router,
        store,
        render: h => h(App)
    });
}

createApp();
